// @ts-nocheck

import React, { useEffect, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { OddArrow } from '../../assets/svg';
import usePrevious from '../../hooks/usePrevious';
import theme from '../../styled-components/dark';

const NB_ARROWS = 3;
const ANIMATION_DURATION = NB_ARROWS * 750;
const ARROW_ANIM_DURATION = ANIMATION_DURATION / NB_ARROWS;

const HEIGHT = 2;

const keyframe = (isUp: boolean) => keyframes`
  from {
    opacity: 0;
    ${
      isUp
        ? css`
            transform: translateY(0) rotate(0deg);
          `
        : css`
            top: translateY(0) rotate(180deg);
          `
    }
  }

  20% {
    opacity: 1;
  }

  80% {
    opacity: 1;
  }

  to {
    opacity: 0;
    ${
      isUp
        ? css`
            transform: translateY(-${HEIGHT}em) rotate(0deg);
          `
        : css`
            transform: translateY(${HEIGHT}em) rotate(180deg);
          `
    }
  }
`;

const Wrap = styled.div``;

const InnerWrap = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const StyledOddArrow = styled(OddArrow)`
  position: absolute;
  display: block;
  width: 100%;
  height: ${HEIGHT / 2}em;
  opacity: 0;

  ${({ $isUp, $index = 0, $isWhite }) => {
    if ($isUp !== null) {
      if ($isUp) {
        return css`
          animation: ${keyframe($isUp)} ${ARROW_ANIM_DURATION}ms linear ${($index * ARROW_ANIM_DURATION) / 4.5}ms 3;
          color: ${$isWhite ? theme.Odd.normal : theme.Odd.isUp};
          bottom: 0;
          transform: none;
        `;
      } else {
        return css`
          animation: ${keyframe($isUp)} ${ARROW_ANIM_DURATION}ms linear ${($index * ARROW_ANIM_DURATION) / 4.5}ms 3;
          color: ${$isWhite ? theme.Odd.normal : theme.Odd.isDown};
          top: 0;
          transform: rotate(180deg);
        `;
      }
    }
  }};
`;

type OddUpdateIndicatorProps = {
  className?: string;
  value: number | null;
  isWhite?: boolean;
  isFixed?: boolean;
};

const OddUpdateIndicator = ({ className = '', value, isWhite = false }: OddUpdateIndicatorProps) => {
  const [animate, setAnimate] = useState<number>(0);
  const previousValue = usePrevious(value);

  useEffect(() => {
    if (previousValue !== undefined && value && value !== previousValue) {
      setAnimate(Math.sign(value - previousValue ?? 0));
    }
  }, [value, previousValue]);

  const arrows = [];
  for (let i = 0; i < NB_ARROWS; i++) {
    arrows.push(
      <StyledOddArrow key={`arrow-${i}`} $index={i} $isUp={animate !== 0 ? animate > 0 : null} $isWhite={isWhite} />,
    );
  }

  return (
    <Wrap className={`${className} odds-update-indicator`}>
      <InnerWrap key={value}>{arrows}</InnerWrap>
    </Wrap>
  );
};

export default OddUpdateIndicator;
